import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import LogoCarousel from '../components/LogoCarousel';
import Stats from '../components/Stats';
import About from '../components/About';
import Experience from '../components/Experience';
import Leadership from '../components/Leadership';
import Education from '../components/Education';
import Skills from '../components/Skills';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import OrganizationsFounded from '../components/WebsiteEmbeds';
import FeaturedPress from '../components/FeaturedPress';
import PhotoGallery from '../components/PhotoGallery';
import Certifications from '../components/Certifications';
import Projects from '../components/Projects';
import { useLanguage } from '../context/LanguageContext';
const Home = () => {
  const {
    language,
    toggleLanguage
  } = useLanguage();
  // Initialize intersection observer for scroll animations
  useEffect(() => {
    const observerCallback = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
          const elements = entry.target.querySelectorAll('.fade-in, .slide-in-left, .slide-in-right, .scale-in, .staggered-text, .slide-up');
          elements.forEach((el, index) => {
            setTimeout(() => {
              el.classList.add('active');
            }, index * 100);
          });
        }
      });
    };
    const observer = new IntersectionObserver(observerCallback, {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    });
    // Observe all sections and elements with animation classes
    document.querySelectorAll('section, .section-transition, .staggered-text, .slide-up').forEach(section => {
      observer.observe(section);
    });
    return () => {
      observer.disconnect();
    };
  }, []);
  return <div className="w-full min-h-screen bg-background text-primary font-body overflow-x-hidden" data-id="element-546">
      <Navbar language={language} toggleLanguage={toggleLanguage} data-id="element-547" />
      <Hero language={language} toggleLanguage={toggleLanguage} data-id="element-548" />
      <LogoCarousel data-id="element-549" />
      <Stats language={language} data-id="element-550" />
      <About language={language} data-id="element-551" />
      <PhotoGallery language={language} data-id="element-552" />
      <Education language={language} data-id="element-553" />
      <Experience language={language} data-id="element-554" />
      <Certifications language={language} data-id="element-555" />
      <Skills language={language} data-id="element-556" />
      <OrganizationsFounded language={language} data-id="element-557" />
      <FeaturedPress language={language} data-id="element-558" />
      <Projects language={language} data-id="element-559" />
      <Leadership language={language} data-id="element-560" />
      <Contact language={language} data-id="element-561" />
      <Footer language={language} data-id="element-562" />
    </div>;
};
export default Home;